export default __webpack_public_path__ + "static/media/DroneAgriculture.b2c5487b.png";